import classNames from 'classnames'
import { AnchorHTMLAttributes } from 'react'
import { LinkProps } from 'react-router'

export const PlainLink = ({
  as = 'a',
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  to?: string
  as?: React.ElementType<React.RefAttributes<HTMLAnchorElement> & LinkProps>
}) => {
  const Link = as

  return (
    <Link
      {...props}
      to={props.to ?? ''}
      className={classNames(
        'underline font-semibold inline text-primary-500 hover:text-primary-800 appearance-none p-0 bg-transparent border-none cursor-pointer',
        props['aria-disabled'] == true ? 'opacity-30 cursor-not-allowed! pointer-events-none' : '',
        props.className
      )}
    >
      {props.children}
    </Link>
  )
}
